<template>
  <div id="payment-index">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'PaymentIndex'
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/PaymentIndex.vue